/* Featured showcase — scroll reveal + subtle pointer-driven 3D tilt (Universal AV Solutions) */
(function () {
  'use strict';

  var root = document.querySelector('[data-av-showcase]');
  if (!root) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-av-tilt]'));
  if (!cards.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fineHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- staggered reveal on scroll ---- */
  root.classList.add('av-js');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    cards.forEach(function (card, i) {
      card.style.setProperty('--av-delay', (i * 0.12) + 's');
      io.observe(card);
    });
  } else {
    cards.forEach(function (card) { card.classList.add('is-visible'); });
  }

  /* ---- 3D tilt + glare + product parallax (mouse / trackpad only) ---- */
  if (!fineHover || reduceMotion) return;

  cards.forEach(function (card) {
    var frame = 0;
    var px = 0;
    var py = 0;

    function paint() {
      frame = 0;
      card.style.setProperty('--ry', (px * 8).toFixed(2) + 'deg');
      card.style.setProperty('--rx', (py * -7).toFixed(2) + 'deg');
      card.style.setProperty('--px', px.toFixed(3));
      card.style.setProperty('--py', py.toFixed(3));
      card.style.setProperty('--mx', ((px + 0.5) * 100).toFixed(1) + '%');
      card.style.setProperty('--my', ((py + 0.5) * 100).toFixed(1) + '%');
    }

    card.addEventListener('pointerenter', function () {
      card.classList.add('is-tilting');
    });

    card.addEventListener('pointermove', function (e) {
      var rect = card.getBoundingClientRect();
      px = (e.clientX - rect.left) / rect.width - 0.5;
      py = (e.clientY - rect.top) / rect.height - 0.5;
      if (!frame) frame = window.requestAnimationFrame(paint);
    });

    card.addEventListener('pointerleave', function () {
      card.classList.remove('is-tilting');
      if (frame) { window.cancelAnimationFrame(frame); frame = 0; }
      px = 0;
      py = 0;
      paint();
    });
  });
})();
